var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-column mb-0 jc-center hp-10" }, [
    _c(
      "div",
      { staticClass: "acenter mb-6" },
      [
        _c("img", {
          staticClass: "w-5 mb-8",
          attrs: {
            src:
              "/ressources/public/img/onboarding/Sellsy_produit_onboarding3.png"
          }
        }),
        _vm._v(" "),
        _vm._t("default", [
          _c("h1", { staticClass: "mb-2" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$l10n.__(
                    "Merci de votre confiance et bonne journée sur Sellsy !"
                  )
                ) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "mt-4",
            attrs: { label: _vm.$t.__("common.actions.go_sellsy") },
            on: { click: _vm.homeUrl }
          })
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }